/**
 * Shipping fee calculation constants and helper functions
 */

export const FREE_SHIPPING_THRESHOLD = 50000;
export const STANDARD_SHIPPING_FEE = 5000;

/**
 * Calculates shipping cost based on order subtotal
 * @param subtotal - The cart subtotal in ARS
 * @returns 0 if subtotal >= FREE_SHIPPING_THRESHOLD, otherwise STANDARD_SHIPPING_FEE
 */
export function calculateShippingCost(subtotal: number): number {
  if (subtotal >= FREE_SHIPPING_THRESHOLD) {
    return 0;
  }
  return STANDARD_SHIPPING_FEE;
}
